import { gql } from '@/__generated__';
import { DataExtraction_GetReportTemplatesQuery } from '@/__generated__/graphql';

export type ReportTemplate = DataExtraction_GetReportTemplatesQuery['reportTemplates'][number];

export const GET_TEMPLATES = gql(`#graphql
  query Reports_GetTemplates {
    reportTemplates {
      id
      name
      emails
      devices {
        id
        profile {
          id
          name
        }
      }
      metrics {
        name
        unit
      }
      meanWindow
      createdAt
      relativeTime
      start
      stop
      schedules {
        id
      }
    }
  }
`);
